import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { ReorderActivities } from './reorder-activities';
import { BaseDialog } from '@/components/shared/base-dialog';
import type { Activity } from '@/data/idp/plans/interfaces';
import { useReorderActivities } from '@/data/idp/plans/reorder-activities';
import { IdpEvent } from '@/constants/analytics';
import {
  buildIdpPlanProperties,
  useIdpPlan,
} from '@/packages/idp/utils/idp-analytics';
import { track } from '@/utils/analytics';

interface ReorderDialogProps {
  activities: Activity[];
  planId: string;
  onClose: () => void;
}

export const ReorderDialog = ({
  activities,
  planId,
  onClose,
}: ReorderDialogProps) => {
  const [items, setItems] = useState(activities);
  const { mutate: reorderActivities, isPending } = useReorderActivities(planId);
  const planProperties = buildIdpPlanProperties(useIdpPlan(planId));

  const handleSubmit = () => {
    reorderActivities(items, {
      onSuccess: () => {
        track(IdpEvent.ActivitiesReordered, {
          ...planProperties,
          moved_count: items.filter(
            (item, index) => item.id !== activities[index]?.id
          ).length,
        });
        onClose();
      },
    });
  };

  return (
    <BaseDialog
      title="Reordenar atividades"
      onClose={onClose}
      actionsComponent={
        <>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            loading={isPending}
          >
            Salvar
          </Button>
        </>
      }
    >
      <Typography mb={2}>Altere a ordem arrastando as atividades</Typography>
      <ReorderActivities
        activities={items}
        planId={planId}
        updateActivities={setItems}
      />
    </BaseDialog>
  );
};
